module.exports = __webpack_public_path__ + "img/perfil.d2a83a17.svg";